// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/market_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's market_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/market_model.proto.
 */
export const file_devtool_emodel_v1_market_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_type_date]);

/**
 * Tenor represents an interest rate or commodity tenor.
 *
 * @generated from message devtool.emodel.v1.Tenor
 */
export type Tenor = Message<"devtool.emodel.v1.Tenor"> & {
  /**
   * @generated from oneof devtool.emodel.v1.Tenor.value
   */
  value: {
    /**
     * @generated from field: devtool.emodel.v1.TenorPeriod period = 1;
     */
    value: TenorPeriod;
    case: "period";
  } | {
    /**
     * @generated from field: devtool.emodel.v1.TenorSpecial special = 2;
     */
    value: TenorSpecial;
    case: "special";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message devtool.emodel.v1.Tenor.
 * Use `create(TenorSchema)` to create a new message.
 */
export const TenorSchema: GenMessage<Tenor> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 0);

/**
 * TenorPeriod represents a tenor as years/months/days.
 *
 * @generated from message devtool.emodel.v1.TenorPeriod
 */
export type TenorPeriod = Message<"devtool.emodel.v1.TenorPeriod"> & {
  /**
   * @generated from field: int32 years = 1;
   */
  years: number;

  /**
   * @generated from field: int32 months = 2;
   */
  months: number;

  /**
   * @generated from field: int32 days = 3;
   */
  days: number;
};

/**
 * Describes the message devtool.emodel.v1.TenorPeriod.
 * Use `create(TenorPeriodSchema)` to create a new message.
 */
export const TenorPeriodSchema: GenMessage<TenorPeriod> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 1);

/**
 * Expiry represents a commodity contract expiry.
 *
 * @generated from message devtool.emodel.v1.Expiry
 */
export type Expiry = Message<"devtool.emodel.v1.Expiry"> & {
  /**
   * @generated from oneof devtool.emodel.v1.Expiry.value
   */
  value: {
    /**
     * @generated from field: google.type.Date date = 1;
     */
    value: Date;
    case: "date";
  } | {
    /**
     * @generated from field: devtool.emodel.v1.TenorPeriod period = 2;
     */
    value: TenorPeriod;
    case: "period";
  } | {
    /**
     * @generated from field: devtool.emodel.v1.FutureContinuationExpiry continuation = 3;
     */
    value: FutureContinuationExpiry;
    case: "continuation";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message devtool.emodel.v1.Expiry.
 * Use `create(ExpirySchema)` to create a new message.
 */
export const ExpirySchema: GenMessage<Expiry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 2);

/**
 * FutureContinuationExpiry represents a rolling future (c1, c2, c3, ...).
 *
 * @generated from message devtool.emodel.v1.FutureContinuationExpiry
 */
export type FutureContinuationExpiry = Message<"devtool.emodel.v1.FutureContinuationExpiry"> & {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset: number;
};

/**
 * Describes the message devtool.emodel.v1.FutureContinuationExpiry.
 * Use `create(FutureContinuationExpirySchema)` to create a new message.
 */
export const FutureContinuationExpirySchema: GenMessage<FutureContinuationExpiry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 3);

/**
 * QuoteID uniquely identifies a market data point.
 *
 * @generated from message devtool.emodel.v1.QuoteID
 */
export type QuoteID = Message<"devtool.emodel.v1.QuoteID"> & {
  /**
   * @generated from field: string instrument_type = 1;
   */
  instrumentType: string;

  /**
   * @generated from field: string quote_type = 2;
   */
  quoteType: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: optional devtool.emodel.v1.Expiry expiry = 5;
   */
  expiry?: Expiry;
};

/**
 * Describes the message devtool.emodel.v1.QuoteID.
 * Use `create(QuoteIDSchema)` to create a new message.
 */
export const QuoteIDSchema: GenMessage<QuoteID> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 4);

/**
 * ContractSpec defines the contract specification for a commodity.
 *
 * @generated from message devtool.emodel.v1.ContractSpec
 */
export type ContractSpec = Message<"devtool.emodel.v1.ContractSpec"> & {
  /**
   * @generated from field: devtool.emodel.v1.ContractFrequency contract_frequency = 1;
   */
  contractFrequency: ContractFrequency;

  /**
   * @generated from field: int32 expiry_month_lag = 2;
   */
  expiryMonthLag: number;

  /**
   * @generated from field: devtool.emodel.v1.AnchorType anchor_type = 3;
   */
  anchorType: AnchorType;
};

/**
 * Describes the message devtool.emodel.v1.ContractSpec.
 * Use `create(ContractSpecSchema)` to create a new message.
 */
export const ContractSpecSchema: GenMessage<ContractSpec> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 5);

/**
 * ExposureProfile contains exposure metric time series.
 *
 * @generated from message devtool.emodel.v1.ExposureProfile
 */
export type ExposureProfile = Message<"devtool.emodel.v1.ExposureProfile"> & {
  /**
   * Expected Positive Exposure at each date.
   *
   * @generated from field: repeated double epe = 1;
   */
  epe: number[];

  /**
   * Expected Negative Exposure at each date.
   *
   * @generated from field: repeated double ene = 2;
   */
  ene: number[];

  /**
   * PFE at various quantiles.
   *
   * @generated from field: repeated devtool.emodel.v1.QuantileValues pfe = 3;
   */
  pfe: QuantileValues[];

  /**
   * Peak EPE over all dates.
   *
   * @generated from field: double epe_peak = 4;
   */
  epePeak: number;

  /**
   * Peak (most negative) ENE over all dates.
   *
   * @generated from field: double ene_peak = 5;
   */
  enePeak: number;

  /**
   * Evaluation dates (optional, for charting).
   *
   * @generated from field: repeated google.type.Date dates = 6;
   */
  dates: Date[];

  /**
   * Discounted Expected Exposure: EE_b[t] = EPE[t] / DF(t).
   * When discount factors are not provided, DF(t) = 1.0 (no discounting).
   *
   * @generated from field: repeated double ee_b = 10;
   */
  eeB: number[];

  /**
   * Effective Expected Exposure: running max of EE_b.
   * EEE_b[t] = max(EEE_b[t-1], EE_b[t]).
   *
   * @generated from field: repeated double eee_b = 11;
   */
  eeeB: number[];

  /**
   * Effective Expected Positive Exposure: time-weighted average of EEE_b within 1 year.
   *
   * @generated from field: double eepe = 12;
   */
  eepe: number;
};

/**
 * Describes the message devtool.emodel.v1.ExposureProfile.
 * Use `create(ExposureProfileSchema)` to create a new message.
 */
export const ExposureProfileSchema: GenMessage<ExposureProfile> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 6);

/**
 * QuantileValues contains PFE values for a single quantile.
 *
 * @generated from message devtool.emodel.v1.QuantileValues
 */
export type QuantileValues = Message<"devtool.emodel.v1.QuantileValues"> & {
  /**
   * Quantile in basis points (e.g., 9500 = 95%).
   *
   * @generated from field: int32 quantile_bps = 1;
   */
  quantileBps: number;

  /**
   * Daily PFE values.
   *
   * @generated from field: repeated double values = 2;
   */
  values: number[];
};

/**
 * Describes the message devtool.emodel.v1.QuantileValues.
 * Use `create(QuantileValuesSchema)` to create a new message.
 */
export const QuantileValuesSchema: GenMessage<QuantileValues> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 7);

/**
 * XVAMetrics contains CVA/DVA/FVA results.
 *
 * @generated from message devtool.emodel.v1.XVAMetrics
 */
export type XVAMetrics = Message<"devtool.emodel.v1.XVAMetrics"> & {
  /**
   * @generated from field: double cva = 1;
   */
  cva: number;

  /**
   * @generated from field: double dva = 2;
   */
  dva: number;

  /**
   * @generated from field: double fva = 3;
   */
  fva: number;

  /**
   * @generated from field: map<string, double> cva_by_netting_set = 10;
   */
  cvaByNettingSet: { [key: string]: number };

  /**
   * Funding Cost Adjustment (borrowing cost on negative exposure).
   *
   * @generated from field: double fca = 11;
   */
  fca: number;

  /**
   * Funding Benefit Adjustment (lending benefit on positive exposure).
   *
   * @generated from field: double fba = 12;
   */
  fba: number;
};

/**
 * Describes the message devtool.emodel.v1.XVAMetrics.
 * Use `create(XVAMetricsSchema)` to create a new message.
 */
export const XVAMetricsSchema: GenMessage<XVAMetrics> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 8);

/**
 * HazardRateTermStructure provides a piecewise-constant hazard rate curve.
 * When provided, survival probability is computed as:
 *   S(t) = exp(-Σ h(t_i) * Δt_i)
 * where h(t_i) is the hazard rate at each tenor, linearly interpolated.
 *
 * @generated from message devtool.emodel.v1.HazardRateTermStructure
 */
export type HazardRateTermStructure = Message<"devtool.emodel.v1.HazardRateTermStructure"> & {
  /**
   * Tenors in years (must be sorted ascending). E.g., [0.5, 1.0, 2.0, 3.0, 5.0].
   *
   * @generated from field: repeated double tenors_years = 1;
   */
  tenorsYears: number[];

  /**
   * Hazard rates at each tenor.
   *
   * @generated from field: repeated double hazard_rates = 2;
   */
  hazardRates: number[];
};

/**
 * Describes the message devtool.emodel.v1.HazardRateTermStructure.
 * Use `create(HazardRateTermStructureSchema)` to create a new message.
 */
export const HazardRateTermStructureSchema: GenMessage<HazardRateTermStructure> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 9);

/**
 * XVAConfig provides parameters for XVA calculation.
 *
 * @generated from message devtool.emodel.v1.XVAConfig
 */
export type XVAConfig = Message<"devtool.emodel.v1.XVAConfig"> & {
  /**
   * @generated from field: double counterparty_hazard_rate = 1;
   */
  counterpartyHazardRate: number;

  /**
   * @generated from field: double own_hazard_rate = 2;
   */
  ownHazardRate: number;

  /**
   * Recovery rate (default 0.4 if unset).
   *
   * @generated from field: double recovery_rate = 3;
   */
  recoveryRate: number;

  /**
   * @generated from field: double funding_spread = 4;
   */
  fundingSpread: number;

  /**
   * Term structure for counterparty hazard rate (overrides flat counterparty_hazard_rate).
   *
   * @generated from field: optional devtool.emodel.v1.HazardRateTermStructure counterparty_hazard_curve = 10;
   */
  counterpartyHazardCurve?: HazardRateTermStructure;

  /**
   * Term structure for own hazard rate (overrides flat own_hazard_rate).
   *
   * @generated from field: optional devtool.emodel.v1.HazardRateTermStructure own_hazard_curve = 11;
   */
  ownHazardCurve?: HazardRateTermStructure;

  /**
   * Separate funding spreads for FCA/FBA decomposition.
   * When unset, funding_spread is used for both directions.
   *
   * @generated from field: optional double funding_spread_lending = 12;
   */
  fundingSpreadLending?: number;

  /**
   * @generated from field: optional double funding_spread_borrowing = 13;
   */
  fundingSpreadBorrowing?: number;
};

/**
 * Describes the message devtool.emodel.v1.XVAConfig.
 * Use `create(XVAConfigSchema)` to create a new message.
 */
export const XVAConfigSchema: GenMessage<XVAConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 10);

/**
 * IborFloatingLegData represents an IBOR-based floating leg.
 *
 * @generated from message devtool.emodel.v1.IborFloatingLegData
 */
export type IborFloatingLegData = Message<"devtool.emodel.v1.IborFloatingLegData"> & {
  /**
   * @generated from field: string index_name = 1;
   */
  indexName: string;

  /**
   * @generated from field: double spread = 2;
   */
  spread: number;

  /**
   * @generated from field: bool is_in_arrears = 3;
   */
  isInArrears: boolean;

  /**
   * @generated from field: int32 fixing_days = 4;
   */
  fixingDays: number;
};

/**
 * Describes the message devtool.emodel.v1.IborFloatingLegData.
 * Use `create(IborFloatingLegDataSchema)` to create a new message.
 */
export const IborFloatingLegDataSchema: GenMessage<IborFloatingLegData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 11);

/**
 * CommodityFloatingLegData represents a commodity-based floating leg.
 *
 * @generated from message devtool.emodel.v1.CommodityFloatingLegData
 */
export type CommodityFloatingLegData = Message<"devtool.emodel.v1.CommodityFloatingLegData"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: devtool.emodel.v1.PriceType price_type = 2;
   */
  priceType: PriceType;

  /**
   * @generated from field: bool is_averaged = 3;
   */
  isAveraged: boolean;

  /**
   * @generated from field: int32 future_month_offset = 4;
   */
  futureMonthOffset: number;

  /**
   * @generated from field: devtool.emodel.v1.PricingDateRule pricing_date_rule = 5;
   */
  pricingDateRule: PricingDateRule;

  /**
   * @generated from field: devtool.emodel.v1.ContractFrequency pricing_contract_frequency = 6;
   */
  pricingContractFrequency: ContractFrequency;
};

/**
 * Describes the message devtool.emodel.v1.CommodityFloatingLegData.
 * Use `create(CommodityFloatingLegDataSchema)` to create a new message.
 */
export const CommodityFloatingLegDataSchema: GenMessage<CommodityFloatingLegData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_market_model, 12);

/**
 * TenorSpecial represents standard short tenors.
 *
 * @generated from enum devtool.emodel.v1.TenorSpecial
 */
export enum TenorSpecial {
  /**
   * @generated from enum value: TENOR_SPECIAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TENOR_SPECIAL_ON = 1;
   */
  ON = 1,

  /**
   * @generated from enum value: TENOR_SPECIAL_TN = 2;
   */
  TN = 2,

  /**
   * @generated from enum value: TENOR_SPECIAL_SN = 3;
   */
  SN = 3,
}

/**
 * Describes the enum devtool.emodel.v1.TenorSpecial.
 */
export const TenorSpecialSchema: GenEnum<TenorSpecial> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_market_model, 0);

/**
 * ContractFrequency specifies contract delivery frequency.
 *
 * @generated from enum devtool.emodel.v1.ContractFrequency
 */
export enum ContractFrequency {
  /**
   * @generated from enum value: CONTRACT_FREQUENCY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTRACT_FREQUENCY_MONTHLY = 1;
   */
  MONTHLY = 1,

  /**
   * @generated from enum value: CONTRACT_FREQUENCY_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: CONTRACT_FREQUENCY_DAILY = 3;
   */
  DAILY = 3,
}

/**
 * Describes the enum devtool.emodel.v1.ContractFrequency.
 */
export const ContractFrequencySchema: GenEnum<ContractFrequency> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_market_model, 1);

/**
 * AnchorType specifies the expiry date anchor.
 *
 * @generated from enum devtool.emodel.v1.AnchorType
 */
export enum AnchorType {
  /**
   * @generated from enum value: ANCHOR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ANCHOR_TYPE_DAY_OF_MONTH = 1;
   */
  DAY_OF_MONTH = 1,

  /**
   * @generated from enum value: ANCHOR_TYPE_NTH_WEEKDAY = 2;
   */
  NTH_WEEKDAY = 2,
}

/**
 * Describes the enum devtool.emodel.v1.AnchorType.
 */
export const AnchorTypeSchema: GenEnum<AnchorType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_market_model, 2);

/**
 * ValuationMode controls how NPV/exposure is calculated.
 *
 * @generated from enum devtool.emodel.v1.ValuationMode
 */
export enum ValuationMode {
  /**
   * @generated from enum value: VALUATION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VALUATION_MODE_LEGACY = 1;
   */
  LEGACY = 1,

  /**
   * @generated from enum value: VALUATION_MODE_NPV_DRIVEN = 2;
   */
  NPV_DRIVEN = 2,
}

/**
 * Describes the enum devtool.emodel.v1.ValuationMode.
 */
export const ValuationModeSchema: GenEnum<ValuationMode> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_market_model, 3);

/**
 * PriceType specifies commodity price type.
 *
 * @generated from enum devtool.emodel.v1.PriceType
 */
export enum PriceType {
  /**
   * @generated from enum value: PRICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRICE_TYPE_FUTURE_SETTLEMENT = 1;
   */
  FUTURE_SETTLEMENT = 1,

  /**
   * @generated from enum value: PRICE_TYPE_SPOT = 2;
   */
  SPOT = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PriceType.
 */
export const PriceTypeSchema: GenEnum<PriceType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_market_model, 4);

/**
 * PricingDateRule specifies when the floating price is observed.
 *
 * @generated from enum devtool.emodel.v1.PricingDateRule
 */
export enum PricingDateRule {
  /**
   * @generated from enum value: PRICING_DATE_RULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRICING_DATE_RULE_FUTURE_EXPIRY_DATE = 1;
   */
  FUTURE_EXPIRY_DATE = 1,

  /**
   * @generated from enum value: PRICING_DATE_RULE_FIRST_PRICING_DATE = 2;
   */
  FIRST_PRICING_DATE = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PricingDateRule.
 */
export const PricingDateRuleSchema: GenEnum<PricingDateRule> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_market_model, 5);

